/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BottomOptions.vue?vue&type=template&id=34778cde&scoped=true&"
import script from "./BottomOptions.vue?vue&type=script&lang=js&"
export * from "./BottomOptions.vue?vue&type=script&lang=js&"
import style0 from "./BottomOptions.vue?vue&type=style&index=0&id=34778cde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34778cde",
  null
  
)

export default component.exports